type DashboardTableRefetchOptions = {
    forceHydration?: boolean;
};

type DashboardTableRefetchHandler = (options?: DashboardTableRefetchOptions) => void;

let refetchHandler: DashboardTableRefetchHandler | null = null;
let pendingRefresh = false;
let pendingOptions: DashboardTableRefetchOptions | undefined;

export function registerDashboardTableRefetch(handler: DashboardTableRefetchHandler | null): void {
    refetchHandler = handler;

    if (handler && pendingRefresh) {
        pendingRefresh = false;
        handler(pendingOptions);
        pendingOptions = undefined;
    }
}

export function triggerDashboardTableRefetch(options?: DashboardTableRefetchOptions): void {
    if (refetchHandler) {
        refetchHandler(options);

        return;
    }

    pendingRefresh = true;
    pendingOptions = options;
}
